import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "page-not-found-view flex-centered col-12 py-4",
  style: {"min-height":"75vh"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 d-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex col-12 align-items-center justify-content-center flex-column mt-4 mt-sm-0" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-uppercase py-4 text-center" }, "Updating card details, please wait...")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import { useHead } from "@unhead/vue";
  import { addNewCard } from "@/api/orders";
  import { useMiscStore } from "@/stores/misc";
  import { onBeforeMount, onMounted } from "vue";
  import { useRouter } from "vue-router";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CardRedirect',
  props: {
    orderId: {},
    checkoutId: {}
  },
  setup(__props: any) {

const props = __props;

  useHead({
    title: "Updating your card...",
  });

  const miscStore = useMiscStore();
  const router = useRouter();

  
  onBeforeMount(async () => {
    miscStore.isLoadingOverride = true;
  });
  
  onMounted(async () => {
    await newCardPost();
  });

  async function newCardPost() {
    if (props.orderId && props.checkoutId) {
      const result = await addNewCard(props.orderId, { orderId: props.orderId, checkoutId: props.checkoutId });
      console.log(result)
      if (result.value) {
        router.push({name: "Products", query: {order: props.orderId}});
      }
      else {
        router.push({name: "Products", query: {order: "error"}});
      }
    }
    else {
      router.push({name: "Products", query: {order: "null"}});
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})